<div [ngClass]="{
    'w-100 full-height-mobile position-relative z-max': !viewportService.isLargeViewPort(),
    'h-100': viewportService.isLargeViewPort()}"
    class="d-flex flex-column w-100 overflow-y-auto overflow-x-hidden no-scroll-bar background-white z-max">
    <div [ngClass]="{'w-100': !viewportService.isLargeViewPort(), 'width-400px': viewportService.isLargeViewPort()}"
         class="flex-none row m-0 p-2 background-primary-blue height-70px w-100 shadow z-max align-items-center">
        <div class="col-2">
            <div class="d-flex justify-content-center">
                <div (click)="back()" class="pointer text-reset">
                    <i class="color-white fa-solid fa-chevron-left fa-xl"></i>
                </div>
            </div>
        </div>
        <div class="col-8 m-auto">
            <div class="text-center color-white fs-lg">Add device</div>
        </div>
        <div class="col-2">
            <div class="d-flex justify-content-center">
                <div (click)="close()" class="pointer text-reset">
                    <i class="color-white fa-solid fa-x fa-xl"></i>
                </div>
            </div>
        </div>
    </div>
    <div class="d-flex flex-column gap-3 p-3 w-100 background-white overflow-y-auto overflow-x-hidden no-scroll-bar">
        <app-generic-button
            (click)="addProximitySamplePoint()"
            description="Add BLE scanner"
            [alwaysShowText]="true"
            [buttonText]="'Add BLE scanner'"
            [primaryIcon]="'fa-solid fa-plus'"/>
        <app-generic-button
            (click)="addLoRaGateway()"
            description="Add gateway"
            [alwaysShowText]="true"
            [buttonText]="'Add LoRa gateway'"
            [primaryIcon]="'fa-solid fa-plus'"/>
        <app-generic-button
            (click)="addWaterPoint()"
            description="Add water point"
            [alwaysShowText]="true"
            [buttonText]="'Add water point'"
            [primaryIcon]="'fa-solid fa-plus'"/>
    </div>
</div>
